import axios from "axios";
import {db_url} from "../url";

export default function DB_Orders (token) {
    const add_url = '/mobile/orders'

    const getOrders = (controller, search) => {
        return axios.get(db_url + add_url, {
            signal: controller.signal,
            params: search,
            headers: {
                Authorization: token
            }
        })
    }

    const getOrder = (controller, id) => {
        return axios.get(db_url + add_url , {
            signal: controller.signal,
            params: {
                id: id
            },
            headers: {
                Authorization: token
            }
        })
    }

    const changeStatusOrder = (id) => {
        return axios.put(db_url + add_url, null, {
        // return axios.put("http://127.0.0.1:3002/api_web/v1" + add_url, null, {
            params: {
                id: id
            },
            headers: {
                Authorization: token
            }
        })
    }

    const deleteOrder = (id) => {
        return axios.delete(db_url + add_url, {
            params: {
                id: id
            },
            headers: {
                Authorization: token
            }
        })
    }

    const updateOrder = (id, data) => {
        return axios.post(db_url + add_url, data, {
            params: {
                id: id
            },
            headers: {
                Authorization: token
            }
        })
    }

    const updateOrderDetails = (id, data) => {
        return axios.patch(db_url + add_url, data, {
        // return axios.patch("http://127.0.0.1:3002/api_web/v1/" + add_url, data, {
            params: {
                id: id
            },
            headers: {
                Authorization: token
            }
        })
    }




    return {
        getOrders,
        getOrder,
        changeStatusOrder,
        deleteOrder,
        updateOrder,
        updateOrderDetails,
    }

}